export class ModalPromise {
    result: Promise<any>;
    private _resolve;
    private _reject;
    constructor() {
        this.result = new Promise((resolve, reject) => {
            this._resolve = resolve;
            this._reject = reject;
        });
        this.result.then(null, function() {});
    }
    done(result) {
        this._resolve(result);
    }
    cancel(reason) {
        this._reject(reason);
    }
}
